module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/og_home.2e5799d4.jpg";